import { DatePicker } from 'antd';
import { CalendarAltIcon } from '../../icons/CalendarAltIcon';
import { DateDuration } from '../../utils/date';
import './style.scss';
import moment, { Moment } from 'moment';

type Props = {
  value?: string;
  onChange?: (_: any, dateString: string) => void;
  onBlur?: () => void;
  format?:
    | 'YYYY-MM-DD'
    | 'MM/DD/YYYY'
    | 'DD-MM-YYYY'
    | 'MM/DD/YYYY'
    | 'DD/MM/YYYY';
  minDate?: DateDuration;
  maxDate?: DateDuration;
  disabled?: boolean;
  minDateValue?: any;
};

export const AntDatepicker = ({
  onChange,
  onBlur,
  value,
  minDate,
  maxDate,
  disabled,
  minDateValue,
}: Props) => {
  const disabledDate = (current: Moment) => {
    if (!minDate && !maxDate) return false;

    if (minDateValue)
      return (current &&
        (current < moment(minDateValue).subtract(minDate?.days! + 1, 'days') ||
          (maxDate &&
            current > moment().add(maxDate?.days, 'days')))) as boolean;
    else
      return (current &&
        (current < moment().subtract(minDate?.days! + 1, 'days') ||
          (maxDate &&
            current > moment().add(maxDate?.days, 'days')))) as boolean;
  };

  const handleChange = (date: any, _: string) => {
    const dateFormat = date && date.format('YYYY-MM-DD');
    onChange?.(_, dateFormat);
  };

  // const customFormat = (value: any) => value.format('DD/MM/YYYY');
  const customFormat = ['DD/MM/YYYY', 'DD/MM/YY'];

  return (
    <div className="tru-date-picker-new">
      <DatePicker
        allowClear={true}
        value={!!value ? moment(moment(value!).format()) : undefined}
        disabledDate={disabledDate}
        suffixIcon={<CalendarAltIcon fill="#AFB6BD" />}
        onChange={handleChange}
        onBlur={onBlur}
        format={customFormat}
        disabled={disabled}
        placeholder='Select or Enter a Date'
        getPopupContainer={(triggerNode) => triggerNode?.parentElement!}
        
      />
    </div>
  );
};
